import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import RefundSummary from '../components/refund-summary';
import money, { Money } from '../lib/money';

import { SHARED_NAMESPACE } from '../actions';

import {
  getCommittedMemberships,
  getOrganizerMembership,
  getCurrentPurchase,
} from '../selectors/purchase-selector';

class RefundSummaryContainer extends Component {
  render() {
    return (
      <RefundSummary
        organizerRefund={this.props.organizerRefund}
        organizerMembership={this.props.organizerMembership}
        inviteesRefund={this.props.inviteesRefund}
        inviteesLength={this.props.inviteesLength}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const organizerMembership = getOrganizerMembership(state);
  const purchase = getCurrentPurchase(state);
  const projectedMemberships = get(state, `projections.${ownProps.namespace || SHARED_NAMESPACE}.memberships`);

  if (!projectedMemberships) {
    return {
      purchase,
      organizerMembership,
      organizerRefund: Money.zero(purchase.currencyCode),
      inviteesRefund: Money.zero(purchase.currencyCode),
    };
  }

  const inviteesRefunds = getCommittedMemberships(state)
    .filter((membership) => {
      return membership.id !== organizerMembership.id &&
        !money(projectedMemberships[membership.id].refundableShareAmount).isZero()
    })
    .map((membership) => money(projectedMemberships[membership.id].refundableShareAmount))

  const organizerRefund = get(projectedMemberships,
    `${organizerMembership.id}.refundableShareAmount`, Money.zero(purchase.currencyCode));

  return {
    organizerRefund,
    inviteesRefund: Money.sum(inviteesRefunds),
    inviteesLength: inviteesRefunds.length,
    organizerMembership: getOrganizerMembership(state),
  };
};

export default connect(mapStateToProps)(RefundSummaryContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/refund-summary.container.js